import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator for mute time field
 * Value must be -1 (permanent mute) or greater than 0 (temporary mute in minutes)
 * Value cannot be 0
 */
export function muteTimeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numValue = Number(value);

    if (isNaN(numValue)) {
      return { muteTime: { message: 'Mute time must be a valid number' } };
    }

    // Check if it's -1 (permanent mute) or greater than 0
    if (numValue === -1 || numValue > 0) {
      return null;
    }

    // Invalid value (0 or negative numbers except -1)
    return {
      muteTime: {
        message:
          'Mute time must be -1 (permanent mute) or greater than 0 (minutes)',
        actualValue: numValue,
      },
    };
  };
}
